var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyMoneySquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6ZM10.1354 10.2162C10.1354 10.909 10.699 11.4727 11.3919 11.4727H12.6081C13.927 11.4727 15 12.5457 15 13.8646C15 15.1835 13.927 16.2566 12.6081 16.2566H12.5677V17.5131C12.5677 17.8267 12.3135 18.0808 12 18.0808C11.6865 18.0808 11.4323 17.8267 11.4323 17.5131V16.2566H10.1758C9.86227 16.2566 9.60809 16.0024 9.60809 15.6889C9.60809 15.3753 9.86227 15.1211 10.1758 15.1211H12.6081C13.301 15.1211 13.8646 14.5575 13.8646 13.8646C13.8646 13.1718 13.301 12.6081 12.6081 12.6081H11.3919C10.073 12.6081 9 11.5351 9 10.2162C9 8.89728 10.073 7.82424 11.3919 7.82424H11.4323V6.56771C11.4323 6.25418 11.6865 6 12 6C12.3135 6 12.5677 6.25418 12.5677 6.56771V7.82424H13.8242C14.1378 7.82424 14.3919 8.07842 14.3919 8.39195C14.3919 8.70547 14.1378 8.95965 13.8242 8.95965H11.3919C10.6991 8.95965 10.1354 9.52331 10.1354 10.2162Z",
    fill: "#2E3758"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMoneySquare);
export default __webpack_public_path__ + "static/media/my-money-square.fe046469.svg";
export { ForwardRef as ReactComponent };